import styled from 'styled-components'
import { useSpring, animated } from 'react-spring'
import { useDrag } from 'react-use-gesture'

const DragAndDrop = () => {
    
const divPos = useSpring({x: 0, y: 0})
const bLogoPos = useDrag((params) => {
        divPos.x.set(params.offset[0]);
        divPos.y.set(params.offset[1]);
})



const divPos2 = useSpring({x: 0, y:0})
const bLogoPos2 = useDrag((params) => {
    divPos2.x.set(params.offset[0]);
    divPos2.y.set(params.offset[1]);
})


const divPos3 = useSpring({x: 0, y:0})
const bLogoPos3 = useDrag((params) => {
    divPos3.x.set(params.offset[0]);
    divPos3.y.set(params.offset[1]);
})


const divPos4 = useSpring({x: 0, y:0})
const bLogoPos4 = useDrag((params) => {
    divPos4.x.set(params.offset[0]);
    divPos4.y.set(params.offset[1]);
})


    
    return ( 
        <Container > 

            <animated.div 
            className="img1"
            {...bLogoPos()} style={{
                y: divPos.y,
                x: divPos.x,
            }}>

            </animated.div>

            <animated.div 
            className="img2"
            {...bLogoPos2()} style={{
                y: divPos2.y,
                x: divPos2.x,
            }}>
            </animated.div>

            <animated.div 
            className="img3"
            {...bLogoPos3()} style={{
                y: divPos3.y,
                x: divPos3.x,
            }}>
            </animated.div>
            <animated.div 
            className="img4"
            {...bLogoPos4()} style={{
                y: divPos4.y,
                x: divPos4.x,
            }}>
            </animated.div>

        </Container>
     );
}
 
export default DragAndDrop;

const Container = styled.div`

    display: flex;
    gap: 30px;
    padding-top: 100px;
    
    .img1 {
        background-image: url(https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/zelda-cover-1582028296.jpg?crop=0.563xw:1.00xh;0.416xw,0&resize=640:*);
    }
    .img2 {
        background-image: url(https://play.nintendo.com/images/Masthead_Mario_HeroPose-updated2021.b19a16e5.ed4a1562.png);
    }
    .img3 {
        background-image: url(https://mario.wiki.gallery/images/8/84/MPS_Donkey_Kong_Artwork.png);
    }
    .img4 {
        background-image: url(https://upload.wikimedia.org/wikipedia/en/5/51/Pit_%28Kid_Icarus%29_Ultimate.png);
    }
    
    div {
        background-color: rgb(255, 255, 255);
        width: 100px;
        height: 100px;
        cursor: pointer;
        user-select: none;
        padding: 10px;
        background-size: cover;
        border-radius: 15%;
        box-shadow: 0px 0px 100px -50px black;

        p {
            text-align: center;
            font-size: 25px;
        }
    }

`